import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, easeOut } from "@/components/common/Reveal";

const ARTICLES = [
  {
    titre: "Tout savoir sur la FIMO Marchandises",
    resume: "Objectifs, prérequis, durée et débouchés de la Formation Initiale Minimale Obligatoire.",
    image: "https://images.pexels.com/photos/20862827/pexels-photo-20862827.jpeg?auto=compress&cs=tinysrgb&w=800",
    to: "/nos-formations/transport-de-marchandises/fimo-marchandises",
  },
  {
    titre: "Comprendre la FCO et son renouvellement",
    resume: "La Formation Continue Obligatoire, valable 5 ans, pour maintenir votre carte de qualification.",
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=800&q=80",
    to: "/nos-formations/transport-de-voyageurs/fco-voyageurs",
  },
  {
    titre: "Financer sa formation : CPF, France Travail, OPCO",
    resume: "Tour d'horizon des dispositifs pour financer votre parcours et optimiser votre budget.",
    image: "https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=800",
    to: "/financements",
  },
];

export default function Articles() {
  return (
    <section className="bg-slate-50 py-24 lg:py-32" data-testid="articles">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <Reveal>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.98] tracking-[-0.03em] text-brand-blue sm:text-5xl">
            Actualités & conseils
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <motion.div
              key={a.titre}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: easeOut, delay: i * 0.1 }}
            >
              <Link
                to={a.to}
                className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-[0_2px_8px_rgba(0,35,102,0.05)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,35,102,0.12)]"
                data-testid={`article-${i}`}
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={a.image} alt={a.titre} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-display text-lg font-extrabold leading-snug text-brand-blue">{a.titre}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">{a.resume}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 font-display text-sm font-bold uppercase tracking-tight text-brand-red underline decoration-2 underline-offset-4">
                    En lire plus
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
